module.exports = __webpack_public_path__ + "img/img32.bc597ab2.jpg";